import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { getBaseUrl } from './app/utils/helpers';
import { environment } from './environments/environment';

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  // { provide: LOCALE_ID, useValue: "vi-VN" }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));